// extracted by mini-css-extract-plugin
export default {"primaryScrollbar":"globalStyles_primaryScrollbar__eE4rU","competencies":"Competencies_competencies__FMrFi","mask":"Competencies_mask__c9aEA"};